import { ConfigProvider, Select, SelectProps } from 'antd';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

export const ResponsiveSelect = <T,>(props: SelectProps<T>) => {
  const { fontSize, spacing, screens } = useResponsiveSizes();

  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: screens.xs ? fontSize.xl : fontSize.lg,
          paddingSM: spacing.sm,
          paddingXS: spacing.xs
        },
        components: {
          Select: {
            optionFontSize: screens.xs ? fontSize.lg : fontSize.base,
            optionPadding: `${spacing.sm}px ${spacing.md}px`
          }
        }
      }}
    >
      <Select
        {...props}
        style={{
          minWidth: screens.xs ? 100 : 150,
          ...props.style
        }}
      />
    </ConfigProvider>
  );
};
